
import Event = createjs.Event;

export class Poker2LobbyDataEvent extends Event {
    public static CHANGE_LOBBY_TABLE_DATA: string = "changeLobbyTableData";
    public static PLAY_NOW: string = "playNow";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}
